<template>
  <div id="templatesParametros">
    <div :class="templates.length > 0 ? 'text-right' : 'text-center'">
      <q-btn
        flat
        round
        class="q-ml-md"
        icon="settings"
        color="primary"
      >
        <q-menu>
          <q-list>
            <q-item clickable @click="importarTemplates">
              <q-item-section>
                Importar Templates Modelo
              </q-item-section>
            </q-item>
            <q-item clickable @click="configDomain">
              <q-item-section>
                Configurar Domínio de E-mail
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>

    <template v-if="templates.length > 0">
      <q-table
        title
        :rows="templates"
        :columns="columns"
        row-key="id"
        :separator="separator"
        :loading="listandoTemplate"
        no-data-label="Nenhum resultado encontrado."
        v-model:pagination="pagination"
      >
        <template v-slot:bottom>
          <div></div>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" @click="props.expand = !props.expand && $q.platform.is.mobile">
            <q-td key="id" class="text-right">{{props.row.id}}</q-td>
            <q-td key="padrao"  class="text-center">
              <q-icon
                v-if="props.row.padrao"
                name="check"
                size="24px"
                class="text-positive">
                <q-tooltip
                  max-width='400px'
                  :style="{fontSize:'15px'}"
                  >
                Esse template será usado por padrão caso não tenha selecionado nenhum ao enviar.
                </q-tooltip>
              </q-icon>
            </q-td>
            <q-td key="title">
              {{props.row.title}}
              <q-badge
                v-if="isDourasatPublicado(props.row)"
                class="q-ml-sm"
                :color="statusDourasat(props.row) === 'approved' ? 'positive' : statusDourasat(props.row) === 'rejected' ? 'negative' : 'warning'"
              >
                {{statusDourasat(props.row)}}
              </q-badge>
              <q-badge
                v-if="categoriaDourasat(props.row)"
                class="q-ml-xs"
                color="grey-7"
                outline
              >
                {{categoriaDourasat(props.row)}}
              </q-badge>
              <br><span v-if="!isTemplateWhatsapp(props.row.tipo)">Assunto: {{props.row.subject}}</span>
            </q-td>
            <q-td key="tipo">{{capitalize(props.row.tipo)}}</q-td>
            <q-td key="from_email">{{props.row.from_email}}</q-td>
            <q-td v-if="$q.platform.is.desktop" class="tdfora">
              <div class="divfora">
                <div class="divdentro q-gutter-sm" style="margin-right: 10px">
                  <q-btn
                    v-if="podeDourasatOficial && isTemplatePublicavelDourasat(props.row.tipo) && !isDourasatPublicado(props.row)"
                    @click="publicarDourasat(props.row)"
                    size="12px"
                    class="bg-positive text-white"
                    icon="cloud_upload"
                  >
                    <q-tooltip>Publicar na DouraSat Oficial</q-tooltip>
                  </q-btn>
                  <q-btn
                    v-if="podeDourasatOficial && isDourasatPublicado(props.row)"
                    @click="sincronizarDourasat(props.row)"
                    size="12px"
                    class="bg-info text-white"
                    icon="sync"
                  >
                    <q-tooltip>
                      {{statusDourasat(props.row) === 'draft' ? 'Enviar para aprovação na DouraSat' : 'Atualizar status na DouraSat'}}
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                    @click="duplicateTemplate(props.row)"
                    size="12px"
                    class="bg-secondary text-white"
                    icon="fa fa-copy"
                  >
                    <q-tooltip>
                      Duplicar Template
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                    @click="EditTemplate(props.row)"
                    size="12px"
                    class="bg-primary text-white"
                    icon="edit"
                  >
                    <q-tooltip>
                      Editar Template
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                    @click="deleteTemplate(props.row)"
                    size="12px"
                    class="bg-negative text-white"
                    icon="delete_forever"
                  >
                    <q-tooltip>
                      Excluir Template
                    </q-tooltip>
                  </q-btn>
                </div>
              </div>
            </q-td>
          </q-tr>
          <q-tr v-show="props.expand" :props="props">
            <q-td colspan="100%">
              <div class="q-py-sm q-gutter-sm">
                <q-btn
                  v-if="podeDourasatOficial && isTemplatePublicavelDourasat(props.row.tipo) && !isDourasatPublicado(props.row)"
                  @click="publicarDourasat(props.row)"
                  size="12px"
                  class="bg-positive text-white"
                  icon="cloud_upload"
                >
                  <q-tooltip>Publicar na DouraSat Oficial</q-tooltip>
                </q-btn>
                <q-btn
                  v-if="podeDourasatOficial && isDourasatPublicado(props.row)"
                  @click="sincronizarDourasat(props.row)"
                  size="12px"
                  class="bg-info text-white"
                  icon="sync"
                >
                  <q-tooltip>
                    {{statusDourasat(props.row) === 'draft' ? 'Enviar para aprovação na DouraSat' : 'Atualizar status na DouraSat'}}
                  </q-tooltip>
                </q-btn>
                <q-btn
                  @click="duplicateTemplate(props.row)"
                  size="12px"
                  class="bg-secondary text-white"
                  icon="fa fa-copy"
                >
                  <q-tooltip>
                    Duplicar Template
                  </q-tooltip>
                </q-btn>
                <q-btn
                  @click="EditTemplate(props.row)"
                  size="12px"
                  class="bg-primary text-white"
                  icon="edit"
                >
                  <q-tooltip>
                    Editar Template
                  </q-tooltip>
                </q-btn>
                <q-btn
                  @click="deleteTemplate(props.row)"
                  size="12px"
                  class="bg-negative text-white"
                  icon="delete_forever"
                >
                  <q-tooltip>
                    Excluir Template
                  </q-tooltip>
                </q-btn>
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <q-btn
        @click="loadMore()"
        :label="'Carregar mais ' + pagingTemplate.page + '/' + pagingTemplate.pageCount"
        class="absolute-bottom-right text-white bg-primary"
        style="margin: 0 25px 15px 0"
        :disable="pagingTemplate.page >= pagingTemplate.pageCount || listandoTemplate"
        :loading="listandoTemplate"
      >
        <template v-slot:loading>
          <q-spinner color="white" size="1em" />
        </template>
      </q-btn>
    </template>

    <modal-config-domain-email />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios-auth";
import { Dialog, Loading, format } from "quasar";
import { isTemplateWhatsapp, isTemplatePublicavelDourasat } from "@/utils/templates";

export default {
  name: "templates-parametros",
  data() {
    return {
      separator: "horizontal",
      // Rótulo em português para a categoria que a DouraSat guarda em inglês.
      // Autenticação não é oferecida na publicação (não há fluxo de OTP no
      // DouraSoft), mas pode chegar aqui num template publicado pela API.
      categoriasDourasat: {
        utility: "Utilidade",
        marketing: "Marketing",
        authentication: "Autenticação"
      },
      pagination: {
        rowsPerPage: 0
      },
      columns: [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "center",
          field: row => row.id,
          sortable: true
        },
        {
          name: "padrao",
          align: "center",
          label: "Padrão",
          field: row => row.padrao,
          sortable: true
        },
        {
          name: "title",
          label: "Título",
          field: row => row.title,
          sortable: true,
          align: "left"
        },
        {
          name: "tipo",
          label: "Tipo",
          field: row => row.tipo,
          sortable: true,
          align: "left"
        },
        {
          name: "from_email",
          label: "De",
          field: row => row.from_email,
          sortable: true,
          align: "left"
        },
        {
          name: "tdFora",
          label: "",
        },
      ]
    };
  },
  methods: {
    isTemplateWhatsapp,
    isTemplatePublicavelDourasat,
    importarTemplates() {
      Dialog.create({
        title: "Confirma a importação dos templates modelo?",
        cancel: "Cancelar",
        persistent: true
      })
        .onOk(() => {
          Loading.show();
          axios
            .post("/templates/edit?importar=1")
            .then(res => {
              if (!res.data.success) {
                this.$q.notify({
                  color: "negative",
                  message: "Não foi possível importar os templates.",
                  position: "top-right",
                });
                Loading.hide();
                return;
              }

              Loading.hide();
              this.$q.notify({
                message: res.data.message,
                position: "top-right",
                color: "positive",
                icon: "check"
              });

              this.$store.dispatch("resetPagingTemplate");
              this.$store.dispatch("listarTemplate");
            })
            .catch(error => {
              Loading.hide();
              this.$q.notify({
                message: "Não foi possível importar os templates.",
                position: "top-right",
                color: "negative",
                icon: "warning"
              });
            });
        });
    },
    configDomain() {
      axios
        .get("/templates/config")
        .then(res => {
          if (!res.data.success) {
            this.$q.notify({
              message: res.data.message || "Erro ao buscar configurações",
              position: "top-right",
              color: "negative",
            });
            return;
          }

          this.$store.commit("emailDomainConfig", res.data.options);
          this.$store.commit("openDialogDomainConfig", true);
      })
      .catch(error => {
        this.$q.notify({
          message: error.message || "Erro ao buscar configurações",
          position: "top-right",
          color: "negative"
        });
      });
    },
    loadMore() {
      this.pagingTemplate.page += 1;
      this.$store.commit("pagingTemplate", this.pagingTemplate);
      this.$store.dispatch("listarTemplate");
    },
    // Pergunta ao servidor o que impede excluir e, para template da DouraSat, se ele
    // pode ser apagado também lá (não pode quando outro template do sistema usa o mesmo).
    deleteTemplate(template) {
      Loading.show();

      // O segundo argumento do then cobre só a falha da verificação: erro da confirmação
      // ou da exclusão tem tratamento próprio e não pode virar "não foi possível verificar".
      return axios.get(`/templates/verificar-exclusao/${template.id}`).then(
        res => {
          Loading.hide();

          if (res.error || !res.data || !res.data.success) {
            this.avisoExclusao("Não foi possível verificar o template agora. Tente novamente.", false);
            return;
          }

          const verificacao = res.data;
          if (verificacao.bloqueios && verificacao.bloqueios.length) {
            Dialog.create({
              title: "Não é possível excluir este template",
              message: verificacao.bloqueios.join(" "),
              class: "bg-warning text-white",
              ok: { "text-color": "orange", color: "white" }
            });
            return;
          }

          return this.confirmarExclusao(verificacao.dourasat).then(naDourasat =>
            naDourasat === null ? undefined : this.excluirTemplate(template, naDourasat)
          );
        },
        () => {
          Loading.hide();
          this.avisoExclusao("Não foi possível verificar o template agora. Tente novamente.", false);
        }
      );
    },
    // Resolve null (cancelou), false (só no DouraSoft) ou true (também na DouraSat).
    confirmarExclusao(dourasat) {
      return new Promise(resolve => {
        if (!dourasat) {
          Dialog.create({
            title: "Tem certeza que deseja excluir este template?",
            cancel: "Cancelar",
            persistent: true
          })
            .onOk(() => resolve(false))
            .onCancel(() => resolve(null));
          return;
        }

        Dialog.create({
          title: "Excluir template da DouraSat",
          message: this.mensagemExclusaoDourasat(dourasat),
          options: {
            type: "radio",
            model: "local",
            items: [
              { label: "Só no DouraSoft (o template continua na DouraSat)", value: "local" },
              {
                label: "No DouraSoft e na DouraSat (apaga também na Meta e não dá para desfazer)",
                value: "dourasat",
                disable: !dourasat.pode_excluir
              }
            ]
          },
          cancel: "Cancelar",
          persistent: true
        })
          .onOk(escolha => resolve(escolha === "dourasat" && dourasat.pode_excluir))
          .onCancel(() => resolve(null));
      });
    },
    // Texto puro: títulos vêm do banco e o diálogo não interpreta HTML.
    mensagemExclusaoDourasat(dourasat) {
      const partes = [`Este template está ligado ao template "${dourasat.nome}" da DouraSat.`];
      if (!dourasat.pode_excluir) {
        partes.push(dourasat.motivo);
        const outros = (dourasat.outros_templates || []).map(t => `#${t.id} ${t.title}`);
        if (outros.length) {
          partes.push(`Também usado por: ${outros.join(", ")}.`);
        }
        // De outra empresa o servidor só manda a contagem: nome e título são dela.
        const empresas = dourasat.outras_empresas || 0;
        if (empresas > 0) {
          partes.push(empresas === 1 ? "Também usado por 1 outra empresa." : `Também usado por ${empresas} outras empresas.`);
        }
      }

      return partes.join(" ");
    },
    excluirTemplate(template, naDourasat) {
      Loading.show();

      return axios
        .post(`/templates/delete/${template.id}`, { excluir_dourasat: naDourasat })
        .then(res => {
          Loading.hide();
          if (res.error || !res.data) {
            this.avisoExclusao("Não foi Possível realizar a ação, ou você não possui permissão isto!", false);
            return;
          }

          this.avisoExclusao(res.data.message, res.data.success);
          if (res.data.success) {
            this.$store.dispatch("resetPagingTemplate");
            this.$store.dispatch("listarTemplate");
          }
        })
        .catch(() => {
          Loading.hide();
          this.avisoExclusao("Não foi Possível realizar a ação, ou você não possui permissão isto!", false);
        });
    },
    avisoExclusao(mensagem, sucesso) {
      Dialog.create({
        title: mensagem,
        class: sucesso ? "bg-positive text-white" : "bg-warning text-white",
        ok: { "text-color": sucesso ? "green" : "orange", color: "white" }
      });
    },
    EditTemplate(value) {
      this.$store.dispatch("editarTemplateGet", value);
    },
    duplicateTemplate(value) {
      this.$store.dispatch("duplicateTemplate", value);
    },
    publicarDourasat(template) {
      Dialog.create({
        title: "Publicar na DouraSat Oficial?",
        message:
          "A categoria é como a Meta analisa e tarifa o template. Aviso de cobrança é Utilidade: " +
          "publicar como Marketing custa mais por mensagem e costuma ser recusado. " +
          "Depois de publicado, o conteúdo não poderá ser editado nem excluído pelo DouraSoft.",
        options: {
          type: "radio",
          model: "utility",
          items: [
            { label: "Utilidade — fatura, cobrança, aviso de serviço", value: "utility" },
            { label: "Marketing — divulgação e promoção", value: "marketing" }
          ]
        },
        cancel: "Cancelar",
        persistent: true
      }).onOk(categoria => this.executarAcaoDourasat(
        `/templates/publicar-dourasat/${template.id}`,
        { categoria }
      ));
    },
    sincronizarDourasat(template) {
      this.executarAcaoDourasat(`/templates/status-dourasat/${template.id}`);
    },
    executarAcaoDourasat(url, payload) {
      Loading.show();
      axios.post(url, payload || {}).then(res => {
        Loading.hide();
        this.$q.notify({
          message: res.data.message,
          color: res.data.success ? "positive" : "warning",
          position: "top-right"
        });
        if (res.data.success) {
          this.$store.dispatch("resetPagingTemplate");
          this.$store.dispatch("listarTemplate");
        }
      }).catch(() => {
        Loading.hide();
        this.$q.notify({
          message: "Não foi possível contactar a DouraSat.",
          color: "negative",
          position: "top-right"
        });
      });
    },
    metaDourasat(template) {
      if (!template || !template.dourasat_meta) return null;

      try {
        return typeof template.dourasat_meta === "string"
          ? JSON.parse(template.dourasat_meta)
          : template.dourasat_meta;
      } catch (error) {
        return null;
      }
    },
    isDourasatPublicado(template) {
      const meta = this.metaDourasat(template);
      return Boolean(meta && meta.template_id);
    },
    statusDourasat(template) {
      if (!template.dourasat_meta) return "";

      const meta = this.metaDourasat(template);
      if (!meta) return "desconhecido";

      return meta.status || "desconhecido";
    },
    categoriaDourasat(template) {
      const meta = this.metaDourasat(template);
      if (!meta || !meta.categoria) return "";

      return this.categoriasDourasat[meta.categoria] || meta.categoria;
    },
    qtdsTemplates(){
      return this.templates.length + ' de ' + this.pagingTemplate.count;
    },
    capitalize(value) {
      return format.capitalize(value);
    },
  },
  computed: {
    ...mapGetters([
      "templates",
      "pagingTemplate",
      "totalTemplate",
      "listandoTemplate",
      "tipoWhatsapp",
      "canalDourasat"
    ]),
    // Publicar e consultar status só existem na API oficial da DouraSat: no canal
    // não oficial a mensagem é texto livre e não há template do outro lado. Sem a
    // integração, o backend recusa — o botão só levava o usuário a um erro.
    podeDourasatOficial() {
      return this.tipoWhatsapp === "dourasat" && this.canalDourasat === "whatsapp";
    }
  },
  mounted() {
    this.$store.dispatch("resetPagingTemplate");
    this.$store.dispatch("listarTemplate");
    this.$store.dispatch("carregarConfigWhatsapp");
  },
  watch:{
    counter(valorNovo){
      if(valorNovo >= this.pagingTemplate.pageCount){
        this.counter = 1;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.q-table__card {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
